import { StreamMap, useApiClient } from '@m43/core';
import { MessagePayload } from '@m43/sockets-mark43';
import { DispositionResource } from '@mark43/cad-api';
import { useQuery } from '@tanstack/react-query';
import { useCallback } from 'react';
import { useIntegratedStreams } from '../../common/hooks/use-integrated-streams';

export function useIntegratedActiveDispositionsQuery(props: {
    eventId?: number;
    enabled?: boolean;
}) {
    const apiClient = useApiClient();
    const { eventId, enabled } = props;

    const activeDispositionsQuery = useQuery({
        queryKey: ['GetActiveDispositions', eventId],
        queryFn() {
            if (eventId && enabled) {
                return apiClient
                    .request<DispositionResource.GetActiveDispositions>({
                        method: 'POST',
                        url: `disposition/active_dispositions_for_event/`,
                        data: { agencyEventId: eventId },
                    })
                    .then((res) => {
                        return res.data?.data?.dispositionDto ?? null;
                    });
            }
            return null;
        },
        enabled,
    });

    const onMessage: (message: MessagePayload<StreamMap, 'nudge'>) => number[] = useCallback(
        (message) => {
            const eventNudgeKeys = ['DISP', 'EC'];

            for (const key of eventNudgeKeys) {
                const entries = message.payload.map[key];
                if (!entries) continue;
                for (const entry of entries) {
                    if (eventId && entry.e === eventId) {
                        return [eventId];
                    }
                }
            }

            return [];
        },
        [eventId]
    );

    useIntegratedStreams({
        query: activeDispositionsQuery,
        streamNames: ['nudge'],
        promiseBufferCallback: () => activeDispositionsQuery.refetch(),
        onMessage,
    });

    return activeDispositionsQuery;
}
